import React from 'react';
import { Form, Collapse, Switch, Modal, Checkbox } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import FakeField from 'Parts/ui/components/fields/FakeField';
import TaxReceiptAdminConfigurationInformationForm from './TaxReceiptAdminConfigurationInformationFormContainer';
import TaxReceiptAdminConfigurationOrganizationDetailsForm from './TaxReceiptAdminConfigurationOrganizationDetailsFormContainer';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import FundkyTooltip from 'Parts/ui/components/FundkyTooltip';

import TaxReceiptAdminConfigurationPanel_en from './locales/TaxReceiptAdminConfigurationPanel_en.json';
import TaxReceiptAdminConfigurationPanel_fr from './locales/TaxReceiptAdminConfigurationPanel_fr.json';

import './TaxReceiptAdminConfigurationPanel.less';

class TaxReceiptAdminConfigurationPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      switchActivated: props.configuration && props.configuration.statusId === 1 ? true : false,
      displayActionModal: false,
      acceptActivation: false
    };

    i18next.addResourceBundle(
      'en',
      'TaxReceiptAdminConfigurationPanel',
      TaxReceiptAdminConfigurationPanel_en
    );
    i18next.addResourceBundle(
      'fr',
      'TaxReceiptAdminConfigurationPanel',
      TaxReceiptAdminConfigurationPanel_fr
    );
  }

  componentDidMount() {
    const value =
      this.props.configuration && this.props.configuration.statusId === 1 ? true : false;
    if (this.state.switchActivated != value) {
      this.setState({
        switchActivated: value
      });
    }
  }

  componentDidUpdate() {
    const value =
      this.props.configuration && this.props.configuration.statusId === 1 ? true : false;
    if (this.state.switchActivated != value && !this.state.displayActionModal) {
      this.setState({
        switchActivated: value
      });
    }
  }

  handleActivation = value => {
    this.setState({
      switchActivated: value
    });
    this.showActionModal();
  };

  switchBack = value => {
    this.setState({
      switchActivated: !value
    });
  };

  showActionModal = () => {
    this.setState({
      displayActionModal: true
    });
  };

  hideActionModal = () => {
    this.setState({
      displayActionModal: false,
      acceptActivation: false
    });
  };

  handleCheckboxChange = event => {
    const value = event.target.checked;
    this.setState({
      acceptActivation: value
    });
  };

  handleModalAccept = () => {
    const statusId = this.state.switchActivated ? 1 : 2;

    this.props
      .updateTaxReceiptConfigurationActivation({ statusId }, statusId)
      .then(() => {
        this.hideActionModal();
        this.props.form.resetFields(['TaxReceiptAdminConfigurationPanel-acceptCheckbox']);
      })
      .catch(error => {
        this.hideActionModal();
        this.props.form.resetFields(['TaxReceiptAdminConfigurationPanel-acceptCheckbox']);
        this.setState({
          switchActivated: !this.state.switchActivated
        });
      });
  };

  handleModalCancel = () => {
    this.props.form.resetFields(['TaxReceiptAdminConfigurationPanel-acceptCheckbox']);
    this.hideActionModal();
    this.switchBack(this.state.switchActivated);
  };

  render() {
    const { t } = this.props;
    const Panel = Collapse.Panel;
    const switchDisabled =
      this.props.configuration === null
        ? true
        : !this.props.configuration.prefix ||
          !this.props.configuration.sequence ||
          !this.props.configuration.signature
        ? true
        : false;

    const activationModal = (
      <Modal
        className="TaxReceiptAdminConfigurationPanel--Modal"
        visible={this.state.displayActionModal ? true : false}
        footer={null}
        onCancel={this.handleModalCancel}
        maskClosable
      >
        <FundkyButton
          className="TaxReceiptAdminConfigurationPanel--closeModal"
          type="text"
          icon={['fas', 'times']}
          size="large"
          action={{ func: this.handleModalCancel }}
        />
        <h1>{this.state.switchActivated ? t('activation') : t('deactivation')}</h1>
        <p>
          {this.state.switchActivated ? t('activation-description') : t('deactivation-description')}
        </p>
        <Form.Item>
          {this.props.form.getFieldDecorator('TaxReceiptAdminConfigurationPanel-acceptCheckbox', {
            onChange: this.handleCheckboxChange
          })(
            <Checkbox checked={this.state.acceptActivation}>
              {this.state.switchActivated ? t('activation-checkbox') : t('deactivation-checkbox')}
            </Checkbox>
          )}
        </Form.Item>

        <div className="TaxReceiptAdminConfigurationPanel--buttons">
          <FundkyButton
            className=""
            type="cancel"
            text={t('cancel')}
            size="medium"
            action={{ func: this.handleModalCancel }}
          />
          <FundkyButton
            className=""
            type="primary"
            text={`${t('accept')}`}
            size="medium"
            loading={this.props.isUpdateConfigurationInProgress}
            action={{ func: this.handleModalAccept }}
            disabled={!this.state.acceptActivation}
          />
        </div>
      </Modal>
    );

    const informationTooltip = <FundkyTooltip title={t('information-tooltip')} />;

    return (
      <div className="TaxReceiptAdminConfigurationPanel">
        <p>
          <i>{t('comply-standards')}</i>
        </p>
        <FakeField
          className="TaxReceiptAdminConfigurationPanel__ActivateField"
          label={t('issue-donation-receipts')}
          data={
            <Switch
              className="TaxReceiptAdminConfigurationPanel__ActivateField--switch"
              checked={this.state.switchActivated}
              disabled={switchDisabled}
              checkedChildren={t('activated')}
              unCheckedChildren={t('deactivated')}
              loading={this.props.isUpdateConfigurationInProgress}
              onClick={this.handleActivation}
            />
          }
          tooltip={switchDisabled ? t('complete-configuration') : null}
        />
        {activationModal}
        <Collapse accordion bordered={false} defaultActiveKey={['1']}>
          <Panel
            header={
              <span>
                {t('donation-receipts-information')}
                {/*informationTooltip*/}
              </span>
            }
            key="1"
          >
            <TaxReceiptAdminConfigurationInformationForm {...this.props} />
          </Panel>
          <Panel header={t('organization-details')} key="2">
            <TaxReceiptAdminConfigurationOrganizationDetailsForm {...this.props} />
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default translate('TaxReceiptAdminConfigurationPanel')(TaxReceiptAdminConfigurationPanel);
